export default __webpack_public_path__ + "static/media/container.efa5c2ba.svg";